export enum ETopicUnavailableReason {
  NOT_FOUND = 'not_found',
  SERVER_ERROR = 'server_error',
}

export interface ITopicUnavailableDetail {
  hashtagId: string;
  unavailableReason: ETopicUnavailableReason;
}
